import { render } from "./InspectionDetail.vue?vue&type=template&id=60f9d00e"
import script from "./InspectionDetail.vue?vue&type=script&lang=js"
export * from "./InspectionDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/InspectionDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60f9d00e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60f9d00e', __exports__)) {
    api.reload('60f9d00e', __exports__)
  }
  
  module.hot.accept("./InspectionDetail.vue?vue&type=template&id=60f9d00e", () => {
    api.rerender('60f9d00e', render)
  })

}


export default __exports__